import { FC, memo } from "react";
import { WithStyle } from "../../utils/WithStyle";
import { StyledText } from "./Text.styled";
import { TextProps } from "./types";

export const Component: FC<TextProps> = memo(
    ({
        children = "This is a text.",
        uppercase = false,
        align = "initial",
        color = "inherit",
        lineThrough = false,
        underline = false,
        fontSize = "14px",
        ...restProps
    }) => {
        return (
            <StyledText
                {...{
                    uppercase,
                    align,
                    color,
                    lineThrough,
                    underline,
                    fontSize,
                    ...restProps,
                }}
            >
                {children}
            </StyledText>
        );
    }
);

export const Text: FC<TextProps> & WithStyle = Object.assign(Component, {
    Style: StyledText,
});
